import { ModifikationsstatusListEntry } from './ModifikationsstatusListEntry';
import { ModifikationsstatusTableCell } from './ModifikationsstatusTableCell';

const ModifikationsstatusEntry = {
    List: ModifikationsstatusListEntry,
    Cell: ModifikationsstatusTableCell,
};

export { ModifikationsstatusEntry };
